import React, { forwardRef, useCallback, useState } from 'react';
import { CustomDateTimePickerProps } from '@/types/CustomDateTimePickerProps';
import DatePicker from "react-datepicker";
import { Button } from 'react95-native-rabbl';

export function CustomDateTimePickerButton({
  selectedDate,
  onPickDate,
  minDate,
  maxDate,
  buttonText,
}: CustomDateTimePickerProps) : React.ReactNode {
  const [internalSelectedDate, setInternalSelectedDate] = useState<Date | null>(selectedDate);
  
  const onInternalPickDate = useCallback((date: Date | null) => {
    setInternalSelectedDate(date);
    if (date) {
      onPickDate(date);
    }
  }, [onPickDate]);

  // https://reactdatepicker.com/#example-custom-input
  // https://github.com/Hacker0x01/react-datepicker/blob/main/docs/datepicker.md
  return (
    <>
      <DatePicker
        selected={internalSelectedDate}
        onChange={onInternalPickDate}
        customInput={
          <Button
            onPress={() => {
              // DatePicker handles the actual onClick
            }}
          >
            {buttonText}
          </Button>
        }
        minDate={minDate}
        maxDate={maxDate}

        // This doesn't need to exist: https://reactdatepicker.com/#example-portal-by-id
        // This causes the element to be placed outside the immediate context which
        // avoids zIndex and clipping issues.
        portalId="root-portal"
      />
    </>
  );
};
